import { useEffect, useState } from "react";
import { Bot, ListChecks } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { useApp, useModule } from "../context/AppContext";
import { PageHeader, Loading, ErrorBox, Denied } from "../components/common";

export default function AiAssist() {
  const allowed = useModule("ai_assist");
  const { meta } = useApp();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { if (allowed) api.get("/dashboard").then((r) => setD(r.data)).catch((e) => setErr(errMsg(e))); }, [allowed]);
  if (!allowed) return <Denied />;
  const label = (k, s) => meta.modules.find((m) => m.key === k)?.statuses?.find((x) => x.key === s)?.label || s;
  return (
    <div data-testid="ai-assist-page">
      <PageHeader crumbs={["Planning & Monitoring", "AI-Assisted Records"]} title="AI-Assisted Records & Reporting" subtitle="Module 22" />
      <div className="rounded-md border border-amber-300 bg-amber-50 p-4 flex gap-3 mb-6" data-testid="ai-disabled-banner">
        <Bot className="h-5 w-5 text-amber-700 shrink-0" />
        <div className="text-sm text-amber-900">
          <p className="font-semibold">AI features are disabled for this deployment.</p>
          <p>No resident or case data is sent to any third-party AI service. Below is a rule-based (non-AI) summary generated from your accessible records. It is a suggestion for human review, not an official determination.</p>
        </div>
      </div>
      {err && <ErrorBox text={err} />}
      {!d && !err && <Loading />}
      {d && (
        <div className="rounded-md border bg-white p-6" data-testid="rule-based-summary">
          <h2 className="font-semibold flex items-center gap-2 mb-4"><ListChecks className="h-4 w-4 text-brand" />Workload summary (rule-based)</h2>
          <ul className="space-y-2 text-sm">
            {d.modules.filter((m) => m.total).map((m) => (
              <li key={m.key}>
                <span className="font-medium">{m.name}:</span> {m.total} record(s) — {Object.entries(m.by_status).map(([s, c]) => `${c} ${label(m.key, s)}`).join(", ")}.
                {m.by_status[m.initial] ? <span className="text-amber-700"> {m.by_status[m.initial]} awaiting first action.</span> : null}
              </li>
            ))}
            {d.compliance_overdue ? <li className="text-red-700 font-medium">{d.compliance_overdue} compliance requirement(s) are past due.</li> : null}
          </ul>
          <p className="mt-4 text-xs text-slate-500">Generated {new Date().toLocaleString("en-PH")} · Requires human review before any official use.</p>
        </div>
      )}
    </div>
  );
}
